<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />		
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewMember ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditMember :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>	
		<v-card-title>
			Members
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="members"
			:search="search"
			class="elevation-1"
		>		
			<template v-slot:[`item.active`]="{ item }">
				<v-icon v-if="item.active" color="success">mdi-checkbox-blank-circle</v-icon>
				<v-icon v-if="!item.active" color="grey">mdi-checkbox-blank-circle</v-icon>
			</template>	
			<template v-slot:[`item.startDate`]="{ item }">
				<span>{{ formateDate(item.startDate, item.endDate) }}</span>
			</template>			
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteMember(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewMember from '../Members/New.vue'
import EditMember from '../Members/Edit.vue'

export default {
  name: 'Members',
	components: {
		Snackbar,
		NewMember,
		EditMember
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,	
	create: false,
	edit: false,
	editId: null,
    members: [],
		search: '',
		headers: [
			{ text: 'Full name', value: 'fullName', width: '10%', align: 'start' },
			{ text: 'Degree', value: 'degree', width: '10%', align: 'start' },
			{ text: 'Active', value: 'active', width: '5%', align: 'start' },
			{ text: 'Email', value: 'email', width: '15%', align: 'start' },
			{ text: 'Contribution period', value: 'startDate', width: '5%', align: 'start' },
			{ text: 'Projects', value: 'projectsIds', width: '25%', align: 'start' },
			{ text: 'Categories', value: 'category', width: '15%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }
		]
  }),
	mounted() {
		this.getMembers();
	},
	methods: {
		formateCategories(category){
			let allCategories = '';
			for(var i=0; i<category.length; i++){
				allCategories += category[i].name;
				if(category[i+1]){
					allCategories += ", ";
				}
			}
			return allCategories;
		},

		formateProjects(projects){
			let allProjects = '';
			for(var i=0; i<projects.length; i++){
				allProjects += projects[i].name;
				if(projects[i+1]){
					allProjects += ", ";
				}
			}
			return allProjects;
		},

		formateDate(startDate, endDate){
			if(endDate){
				return new Date(startDate).toLocaleDateString('es', { year: "numeric", month: "2-digit", day: "2-digit" }) + " ···················· " + new Date(endDate).toLocaleDateString('es', { year: "numeric", month: "2-digit", day: "2-digit" });
			}
			return new Date(startDate).toLocaleDateString('es', { year: "numeric", month: "2-digit", day: "2-digit" });
		},		

		formateMembers(){
			this.members.forEach(e => {
				e.category = this.formateCategories(e.category);
				e.projectsIds = this.formateProjects(e.projectsIds);
			})
		},

		getMembers(){
			axios
			.get(`/member/`)
			.then(res => {
				this.members = res.data.data;
				this.formateMembers();
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this member?");
		},

		deleteMember(member){
			axios
			.delete(`/member/`, {data: {_id: member._id}})
			.then(() => {
        this.deleted = true
				this.getMembers();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getMembers();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getMembers();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}
}
</script>

<style>

</style>